// extracted by mini-css-extract-plugin
export default {"productSwitcherButton":"ProductSwitcher_productSwitcherButton__o7X-u","productSwitcherContent":"ProductSwitcher_productSwitcherContent__d2-r8"};